import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svc-appointment-confirm-delete-dialog',
  templateUrl: './appointment-confirm-delete-dialog.component.html',
  styleUrls: ['./appointment-confirm-delete-dialog.component.scss']
})
export class AppointmentConfirmDeleteDialogComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
